<div class="d-flex w-100 justify-content-between featured-items-header">
  <div class="headline-6--weight-regular">{{ title }}</div>

  <div class="swiper-buttons">
    <div id="prev" class="swiper-button-prev">
      <img src="/images/svg/silent-auction/arrow-left-black.svg">
    </div>

    <div id="next" class="swiper-button-next">
      <img class="image" src="/images/svg/silent-auction/arrow-right-black.svg">
    </div>
  </div>
</div>

<div class="swiper" #swiper>
  <div class="swiper-wrapper swiper--featured-items">
    <div class="col swiper-slide" *ngFor="let item of items; trackBy:identify">
      <div class="additional-info">
        <div *ngIf="item.featured && type === types.featured" class="item-type caption--bold d-flex featured">
          <div class="icon"></div> FEATURED
        </div>

        <ng-container *ngIf="!item.buyItNowOnlyItem else buyItNowTemplate">
          <ng-container *ngIf="item.currentBid else startingTemplate">
            <div *ngIf="auctionHelperService.showBidButton(campaign, item)" class="featured-item-current-bid subtitle-2--regular mt-2 mt-sm-0">
              Current Bid: {{item.currentBid | currency:'USD':'symbol-narrow':'1.0-0' }}
            </div>
          </ng-container>

          <ng-template #startingTemplate>
            <div *ngIf="auctionHelperService.showBidButton(campaign, item)" class="featured-item-current-bid subtitle-2--regular mt-2 mt-sm-0">
              Starting Bid: {{item.minBid | currency:'USD':'symbol-narrow':'1.0-0' }}
            </div>
          </ng-template>
        </ng-container>

        <ng-template #buyItNowTemplate>
          <div *ngIf="auctionHelperService.showBuyItNow(campaign, item)" class="featured-item-current-bid subtitle-2--regular mt-2 mt-sm-0">
            Buy Now For: {{item.buyItNowAmount | currency:'USD':'symbol-narrow':'1.0-0' }}
          </div>
        </ng-template>

      </div>
      <div class="card card--featured-items h-100">
        <div class="card-body card-body--featured-items">
          <img [src]='getImageUrl(item)' class="card-body__image"/>
          <div class="card-body__item-display">
            <h5 class="subtitle-2--regular mb-2 mx-2 mx-sm-0 card-body__item-name">{{item.name}}</h5>
          </div>

          @if (auctionHelperService.getSoldOutBadgeStatus(campaign, item)) {
            <div class="d-flex justify-content-center flex-column h-100 w-100">
              <div class='card__sold text-center'>
                <span class="subtitle-2 py-1 px-4" style="border-radius: 16px;">Sold Out</span>
              </div>
            </div>
          }

          <div class="card-body__buttons">
            <button
              *ngIf="auctionHelperService.showBidButton(campaign, item)"
              class="donor-flow-button donor-flow-button--sm button"
              (click)="bidAgain(item)"
              [ngClass]="buttonClass(item)"
              [disabled]="buttonDisabled(item)"
            >Bid</button>

            <button
              *ngIf="auctionHelperService.showBuyItNow(campaign, item)"
              class="donor-flow-button donor-flow-button--outline donor-flow-button--sm button"
              (click)="buyItNow(item)"
            >Buy Now</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="swiper-pagination"></div>
</div>